import { render, staticRenderFns } from "./brand_edit.vue?vue&type=template&id=200a685c&scoped=true"
import script from "./brand_edit.vue?vue&type=script&lang=js"
export * from "./brand_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200a685c",
  null
  
)

export default component.exports